import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { getPatientDataByURl, PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';
import { FamilyHistoryService } from 'src/app/services/family-history.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { Relation, DiagnosisSearch, DiagnosisSearchResponse, CommonDiseaseResponse, SaveFamilyHXRequest, FamilyHxDiagnosisList, FamilyHistory, DeleteFamilyHX } from 'src/app/models/intake/familyHistory';
import { IntakeService } from 'src/app/services/intake.service';
import { IntakeFieldsSetting } from 'src/app/models/intake/intakeAllergies';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-family-history',
  templateUrl: './family-history.component.html',
  styleUrls: ['./family-history.component.css']
})
export class FamilyHistoryComponent implements OnInit {

  intakeFieldsSetting: IntakeFieldsSetting = new IntakeFieldsSetting();
  patientPersonalInfo: PatientPersonalInfo;
  isRtl: boolean = false;
  newPatientPersonalInfo: getPatientDataByURl;
  landFromCheckin: any;
  isFromNewPatient: boolean = false;
  reasonName: any;
  PracticeCode: any;
  PatientAccount: any;
  constructor(private translateService: TranslateService, private service: FamilyHistoryService, private spinner: NgxSpinnerService, private phrUtils: PhrutillsService, private router: Router, private _intakeser: IntakeService) {

    this.landFromCheckin = localStorage.getItem("landFrom");
    //console.log("landFromCheckin in allergy component", this.landFromCheckin);
    if (this.landFromCheckin == 'drsiteintake' || this.landFromCheckin == 'new_patient') {
      let info = localStorage.getItem('PatientInfo');
      if (!info) {
        this.router.navigateByUrl("/");
        return;
      }
      this.newPatientPersonalInfo = this.phrUtils.decrypt(info) as getPatientDataByURl;
      //console.log("info in intake form PatientInfo", this.newPatientPersonalInfo);
      this.reasonName = this.newPatientPersonalInfo.reasonName;
      this.PracticeCode = this.newPatientPersonalInfo.practiceCode;
      this.PatientAccount = this.newPatientPersonalInfo.patientAccount;
    }
    else {

      let info = localStorage.getItem('PersonalInfo');
      if (!info) {
        this.router.navigateByUrl("/");
        return;
      }
      this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
      //console.log("info in intake form PatientInfo", this.patientPersonalInfo);
     // this.reasonName = this.patientPersonalInfo.REASON_NAME;
      this.PracticeCode = this.patientPersonalInfo.PRACTICE_CODE;
      this.PatientAccount = this.patientPersonalInfo.PATIENT_ACCOUNT;
    }
    //this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
    this.intakeFieldsSetting = this.phrUtils.decrypt(localStorage.getItem("intakeformsetting")) as IntakeFieldsSetting;
  }

  ngOnInit(): void {
    this.phrUtils.patientlanguage$.subscribe(language => {
      console.log("dafault " + language);
      if (language === 'es') {
        this.isRtl = false;
        this.phrUtils.setTitle('Historial Familiar');
      } else if (language === 'hi') {
        this.isRtl = false;
        this.phrUtils.setTitle('पारिवारिक इतिहास');
      }
      else if (language === 'ur') {
        this.isRtl = true;
        this.phrUtils.setTitle('خاندانی ہسٹری');
      }
      else {
        this.isRtl = false;
        this.phrUtils.setTitle('Family History');
      }
    });
    this.GetCommonDisease();
    this.getFamilyHistory();
    this.getRelationsDropDown();
    this.reset();

  }

  //reset careteam formm
  formFamilyHistory = new UntypedFormGroup({});
  reset() {
    this.formFamilyHistory.reset();
    this.formFamilyHistory = new UntypedFormGroup({
      name: new UntypedFormControl(''),
      relationship: new UntypedFormControl('', Validators.required),
      age: new UntypedFormControl('', Validators.max(150)),
      ageonset: new UntypedFormControl('', Validators.max(150)),
      diagnosis: new UntypedFormControl('', Validators.required),
      deceased: new UntypedFormControl(''),
    });

    this.myScrollContainerSearch.nativeElement.checked = true;
  }

  familyHistories: FamilyHistory[] = [];
  getFamilyHistory() {
    this.spinner.show();
    this.service.getFamilyHistory(this.PatientAccount, this.PracticeCode).subscribe((res: any) => {
      this.spinner.hide();
      if (res && res.statusCode == 200) {

        if (res && res.data.familyHistories.length > 0) {
          if (this.familyHistories.length > 0) {
            this.clearFamilyHistories();
          }

          this.familyHistories = res.data.familyHistories as FamilyHistory[];
          this.familyHistories.forEach((item, index) => {
            if (item.familyHistoryDiagnosisDescription && item.familyHistoryDiagnosisDescription != "") {

              let remIcd10 = item.familyHistoryDiagnosisDescription.split("ICD10 : ");
              let actuallIcd10 = remIcd10[1].split(" ICD9:");
              item.familyHistoryDiagnosisDescription = actuallIcd10[0];
            }
          });
        }
        else {
          if (res.message == 'No Record Found') {
            //console.log('no family history found.');
          }
        }
      }
    },
      (error: any) => {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
        this.spinner.hide();
      });
  }

  clearFamilyHistories() {
    this.familyHistories.length = 0;
    this.familyHistories = [];
  }

  relations: Relation[] = [];
  getRelationsDropDown() {
    if (!this.patientPersonalInfo || this.relations.length > 1) {
      return;
    }

    this.spinner.show();
    this.service.getRelationsDropDown(this.PatientAccount, this.PracticeCode).subscribe((res: any) => {
      this.spinner.hide();

      if (res.statusCode == 200) {
        for (let item of res.data.predefinedForms) {

          if (item.frontLabel == "Relationship") {
            let rel = item.options.split(",");
            for (let item of rel) {
              let splitResult = item.split("|");
              let rel = new Relation();
              rel.val = splitResult[0];
              rel.label = splitResult[1];
              if (rel.val && rel.label) {
                this.relations.push(rel);
              }
            }
          }
        }
      }
    },
      (error: any) => {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
        this.spinner.hide();
      });
  }
  get getFamilyForm() {
    return this.formFamilyHistory.controls;
  }

  showSaveFamilyHistoryModal() {
    $('#modalSaveFamilyHistory').modal('show');
  }
  newDiagnosis: CommonDiseaseResponse | null;
  onChangeDisease(e: any): void {
    const selectedDisease = e.target.value;

    //console.log("Selected Disease:", selectedDisease);
    this.newDiagnosis = this.commonDisease.find(disease => disease.diseaseId === selectedDisease) || null;
    // console.log(this.newDiagnosis);
    this.saveFamilyHistory.diagnosisList = [];
    this.saveFamilyHistory.diagnosisList.push({
      icdNineCode: '',
      icdNineDescription: '',
      icdTenCODE: this.newDiagnosis?.icD10Code,
      icdTenDescription: this.newDiagnosis?.diseaseDescription,
      snomedDescription: ""
    });

  }

  commonDisease: CommonDiseaseResponse[] = [];
  GetCommonDisease() {
    // this.isLoading = true;
    this.service.GetCommonDisease(this.PatientAccount, this.PracticeCode).subscribe((res: any) => {
      //console.log("res " , res);
      //  this.isLoading = false;
      this.commonDisease = res.data.commonDiseases as CommonDiseaseResponse[];
      //console.log("common disease " , this.commonDisease);

    }, (error: any) => {
      console.log("Service error")
    });
  }
  diagnosisSearch: DiagnosisSearch = new DiagnosisSearch();
  isLoading = false;
  noRecs = false;
  diagnosis: DiagnosisSearchResponse[] = [];
  dNonediagnosis: boolean = true;
  getDiagnosis(e: any) {

    if (e.target.value.length < 3) {
      this.diagnosis = [];
      this.diagnosis.length = 0;
      return;
    }
    if (e.keyCode == 40 || e.keyCode == 39 || e.keyCode == 38 || e.keyCode == 37) {
      return;
    }
    if (e.target.value.length == 0) {
      this.diagnosis.splice(0, this.diagnosis.length);
      this.diagnosis.length = 0;
      this.dNonediagnosis = true;
      return;
    }
    this.dNonediagnosis = false;
    this.isLoading = true;
    this.diagnosisSearch.PatientAccount = this.PatientAccount;
    this.diagnosisSearch.PracticeCode = this.PracticeCode;
    this.diagnosisSearch.Query = e.target.value;
    this.diagnosisSearch.PaginationSize = "20";
    this.diagnosisSearch.EndTo = "19";
    this.diagnosis = [];
    this.service.getDiagnosis(this.diagnosisSearch)
      .subscribe((res: any) => {
        this.isLoading = false;

        this.diagnosis = res.docs as DiagnosisSearchResponse[];
        if (this.diagnosis.length < 1) {
          this.diagnosis.splice(0, this.diagnosis.length);
          this.diagnosis.length = 0;
          this.noRecs = true;
        }
        else {
          this.noRecs = false;
        }
      }, (error: any) => {
        this.diagnosis.splice(0, this.diagnosis.length);
        this.diagnosis.length = 0;
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
        this.isLoading = false;
      });
  }

  onSelectDiagnos(d: DiagnosisSearchResponse) {
    this.saveFamilyHistory.diagnosisList = [];
    this.getFamilyForm["diagnosis"].setValue(d.ICD10_DESCRIPTION);
    this.saveFamilyHistory.diagnosisList.push({
      icdNineCode: d.ICD9_CODE || '',
      icdNineDescription: d.ICD9CodeDescription || '',
      icdTenCODE: d.ICD10_CODE || '',
      icdTenDescription: d.ICD10_DESCRIPTION,
      snomedDescription: d.ICDs_Synonyms_Data
    });
  }

  @ViewChild('radioNo') myScrollContainerSearch: ElementRef;
  onDeceasedChanged(e: any) {
    this.getFamilyForm["deceased"].setValue(e.target.defaultValue);
  }

  saveFamilyHistory: SaveFamilyHXRequest = new SaveFamilyHXRequest();
  dig: string;
  onSaveFamilyHistory() {

    if (this.formFamilyHistory.invalid) {
      this.formFamilyHistory.markAllAsTouched();
      return;
    }
    if (this.saveFamilyHistory.diagnosisList.length == 0) {
      this.getFamilyForm["diagnosis"].setErrors({ required: true });
      return;
    }

    if (this.getFamilyForm['ageonset'].value > this.getFamilyForm['age'].value) {
      return;
    }

    this.saveFamilyHistory.patientAccount = this.PatientAccount;
    this.saveFamilyHistory.practiceCode = this.PracticeCode;
    this.saveFamilyHistory.familyHistorystructureReconcileId = "-1";
    this.saveFamilyHistory.age = this.getFamilyForm['age'].value;
    this.saveFamilyHistory.name = this.getFamilyForm['name'].value;
    this.saveFamilyHistory.realtionShip = this.getFamilyForm['relationship'].value;
    this.saveFamilyHistory.isDeceased = this.getFamilyForm['deceased'].value;
    this.saveFamilyHistory.validUserId = this.PatientAccount;
    this.saveFamilyHistory.ageAtOnSet = this.getFamilyForm['ageonset'].value;

    this.spinner.show();
    this.service.saveUpdateFamilyHistory(this.saveFamilyHistory).subscribe((res: any) => {
      this.spinner.hide();
      $('#modalSaveFamilyHistory').modal('hide');
      if (res && res.statusCode == 200) {
        let text = "Saved successfully!";
        this.translateService.get('Alerts.family_history_saved').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showSuccess(text);
        //this.phrUtils.showSuccess("Saved successfully!");
        this.getFamilyHistory();
        this.reset();
        this.diagnosis.length = 0;
        this.diagnosis = [];
      }
    },
      (error: any) => {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
        this.spinner.hide();
      });
  }

  onNoKnownFamilyHistory() {
    this.spinner.show();
    // this.service.noKnownFamilyHistory(this.patientPersonalInfo)
    this.service.noKnownFamilyHistory(this.PatientAccount, this.PracticeCode)
      .subscribe((res: any) => {

        this.spinner.hide();
        if (res && res.statusCode == 200 && res.message == "success") {
          let text = "No known family history is set.";
          this.translateService.get('Alerts.family_history_no_known').subscribe((translation: string) => {
            text = translation;
          });
          //this.phrUtils.showInfo(text);
          //this.phrUtils.showSuccess("No known family history is set.");
          this._intakeser.onNoKnown();
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          // this.phrUtils.showError("Service is not available, please try later.");
          this.spinner.hide();
        });
  }

  // *********edit functions ********* 
  editFH: FamilyHistory = new FamilyHistory();
  editFamilyHX(fHX: FamilyHistory) {

    this.editFH = fHX;
    $('#editFamilyHistoryModal').modal('show');
    this.updateFamilyHX.diagnosisList.push({
      icdTenCODE: "",
      icdTenDescription: this.editFH.familyHistoryDiagnosisDescription,
      icdNineCode: "",
      icdNineDescription: "",
      snomedDescription: "",
    });
  }

  updateFamilyHX: SaveFamilyHXRequest = new SaveFamilyHXRequest();;
  onUpdateFamilyHistory() {

    if (!this.editFH.familyHistoryDiagnosisDescription) {
      return;
    }

    this.updateFamilyHX.patientAccount = this.PatientAccount;
    this.updateFamilyHX.practiceCode = this.PracticeCode;
    this.updateFamilyHX.familyHistorystructureReconcileId = this.editFH.familyHistoryId;
    this.updateFamilyHX.age = this.editFH.age;
    this.updateFamilyHX.name = this.editFH.name;
    this.updateFamilyHX.realtionShip = this.editFH.relationship;
    this.updateFamilyHX.isDeceased = this.editFH.isDeceased;
    this.updateFamilyHX.validUserId = this.PatientAccount;
    this.updateFamilyHX.ageAtOnSet = this.editFH.ageAtOnset;

    if (Number(this.editFH.ageAtOnset) > Number(this.editFH.age)) {
      return;
    }
    this.spinner.show();
    this.service.saveUpdateFamilyHistory(this.updateFamilyHX).subscribe((res: any) => {
      this.spinner.hide();
      $('#editFamilyHistoryModal').modal('hide');
      if (res && res.statusCode == 200) {
        let text = "Updated successfully!";
        this.translateService.get('Alerts.family_history_updated').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showSuccess(text);
        //this.phrUtils.showSuccess("Updated successfully!");
        this.getFamilyHistory();
        this.formFamilyHistory.reset();
        this.getFamilyForm["relationship"].setValue('');
      }
    },
      (error: any) => {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
        this.spinner.hide();
      });
  }

  onDeceasedChangedUpdate(e: any) {
    this.editFH.isDeceased = e.target.value;
  }

  onSelectDiagnosUpdate(d: DiagnosisSearchResponse) {
    this.editFH.familyHistoryDiagnosisDescription = d.ICD10_DESCRIPTION;
    this.updateFamilyHX.diagnosisList = [];
    this.updateFamilyHX.diagnosisList.push({
      icdTenCODE: "",
      icdTenDescription: d.ICD10_DESCRIPTION,
      icdNineCode: "",
      icdNineDescription: "",
      snomedDescription: "",
    });
  }
  // **********delete recounciled familyHX**********

  onDeleteFamilyHIstory() {
    let text = "You can't delete family history added by provider";
    this.translateService.get('Alerts.cant_delete_familyHistory').subscribe((translation: string) => {
      text = translation;
    });
    this.phrUtils.showInfo(text);
  }

  // **********delete familyHX**********
  deleteFH: FamilyHistory;
  setDeleteFamilyHX(fHX: FamilyHistory) {

    $('#modalDeleteFamilyHistory').modal('show');
    this.deleteFH = fHX;
  }

  DeleteFamilyHX() {

    this.spinner.show();
    let deleteFHX: DeleteFamilyHX = new DeleteFamilyHX();
    deleteFHX.patientAccount = this.PatientAccount;
    deleteFHX.practiceCode = this.PracticeCode;
    deleteFHX.familyHXId = this.deleteFH.familyHistoryId;

    this.service.DeleteFamilyHX(deleteFHX)
      .subscribe((res: any) => {

        this.spinner.hide();
        if (res && res.statusCode == 200 && res.message == "success") {
          this.getFamilyHistory();
          this.familyHistories.forEach((item, index) => {
            if (item === this.deleteFH) {
              this.familyHistories.splice(index, 1);
              let text = "Deleted successfully.";
              this.translateService.get('Alerts.family_history_deleted').subscribe((translation: string) => {
                text = translation;
              });
              this.phrUtils.showSuccess(text);
              //this.phrUtils.showSuccess("Deleted successfully.");
              this.deleteFH = new FamilyHistory();
            }
          });
          $('#modalDeleteFamilyHistory').modal('hide');
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Service is not available, please try later.");
          this.spinner.hide();
        });
  }

  // ************* validation functions *************
  limitChars(e: any, length: number) {
    e.target.value = e.target.value.replace(/[^a-zA-Z]/g, "");
    if (e.target.value.length === length) {
      return false;
    }
    return true;
  }

  validateName(e: any) {
    var charCode = (e.which) ? e.which : e.keyCode;
    if (charCode == 32) {
      return true;
    }
    else {
      return this.phrUtils.onlyCharacters(e);
    }
  }
}
